import { render, staticRenderFns } from "./myHousekeepingDispatchManage.vue?vue&type=template&id=53c7c361&scoped=true"
import script from "./myHousekeepingDispatchManage.vue?vue&type=script&lang=js"
export * from "./myHousekeepingDispatchManage.vue?vue&type=script&lang=js"
import style0 from "./myHousekeepingDispatchManage.vue?vue&type=style&index=0&id=53c7c361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7c361",
  null
  
)

export default component.exports